'use es6';

import http from 'hub-http/clients/apiClient';
import { DESIGN } from 'DesignData/enums/FolderCategories';
import { userPortal as userPortalLocalStorage, tryConvertLegacyStorage } from 'DesignData/lib/localStorage';
import { FINDER_FOLDERS } from 'DesignData/enums/attributes/UserPortal';
import { STAGED } from 'DesignData/enums/StagingEnvironments';
const legacyKeySuffix = 'finder:folders';
const API_BASE = 'designmanager/v1/folders';
const METADATA_API_BASE = 'designmanager/v1/folder-metadata/folder';
const TIMEOUT = 15000;
export function fetchByQuery(query = {}) {
  return http.get(API_BASE, {
    query
  });
}
export function fetchContents(folderId) {
  // BUG: Occasionally undefined folderIds are being passed in the wild
  // Likely due to a bug in reducer Folders.openById
  if (!folderId) return Promise.resolve();

  if (Array.isArray(folderId)) {
    const ids = folderId.filter(Boolean);
    if (!ids.length) return Promise.resolve();
    return http.get(`${API_BASE}/contents`, {
      query: {
        ids,
        // Loads staged files by default
        environmentId: STAGED
      }
    });
  }

  return http.get(`${API_BASE}/${folderId}/contents`, {
    query: {
      // Loads staged files by default
      environmentId: STAGED
    }
  });
}
export function fetchParents(folderId) {
  return http.get(`${API_BASE}/${folderId}/parents`, {
    timeout: TIMEOUT
  });
}
export function fetchParentIds(folderId) {
  return http.get(`${API_BASE}/${folderId}/parent-folders`);
}
export function addContents(folderId, data) {
  return http.put(`${API_BASE}/${folderId}/contents`, {
    data
  });
}
export function create({
  name,
  subcategory = null,
  parentFolderId = null
}) {
  return http.post(API_BASE, {
    data: {
      category: DESIGN,
      name,
      subcategory,
      parentFolderId
    }
  });
}
export function del(folderId) {
  return http.delete(`${API_BASE}/${folderId}`);
}
export function bulkDelete(folderIds) {
  return http.delete(`${API_BASE}/bulk`, {
    query: {
      id: folderIds
    }
  });
}
export function update(folderId, {
  name
}) {
  return http.put(`${API_BASE}/${folderId}`, {
    data: {
      name
    }
  });
}
export function clone(folderId, label) {
  return http.post(`${API_BASE}/${folderId}/clone`, {
    timeout: TIMEOUT,
    data: {
      label
    }
  });
}
export function lockFolder(folderId, lockMessage) {
  return http.put(`${METADATA_API_BASE}/${folderId}`, {
    data: {
      locked: true,
      lockedMessage: lockMessage
    }
  });
}
export function unlockFolder(folderId) {
  return http.put(`${METADATA_API_BASE}/${folderId}`, {
    data: {
      locked: false
    }
  });
}
/**
 * @param {Number} userId
 * @param {Number} portalId
 * @returns {Promise}
 */

export function fetchOpenFolders(userId, portalId) {
  const storageClient = userPortalLocalStorage(userId, portalId, FINDER_FOLDERS);
  return (tryConvertLegacyStorage(storageClient, legacyKeySuffix, {
    async: false
  }) || storageClient.fetch() || []).filter(d => d !== 'undefined');
}
/**
 * @param {Number} userId
 * @param {Number} portalId
 * @param {Object} data
 * @returns {Promise}
 */

export function saveOpenFolders(userId, portalId, data) {
  const storageClient = userPortalLocalStorage(userId, portalId, FINDER_FOLDERS);
  return storageClient.saveAsync(data);
}